import { type SettingDefaults } from '../api/setting';
import { ca } from '../i18n/ca';
import { theatresOf, useEras } from './useEras';

/**
 * Where a terrain is, asked in the eras in which the place decides who fights.
 *
 * A Second World War night at Tobruk is the Desert Rats against the
 * Afrikakorps, and the same night at Staszów is the Red Army against the
 * Wehrmacht (the owner, 2026-09-19). The platform reads most terrains' names;
 * the ones it cannot are asked here once and remembered for everybody, and a
 * wrong reading is corrected the same way. Nothing is drawn in an era in which
 * the place decides nothing.
 */
export function TheatreAsk({
  defaults,
  onPlace,
}: {
  defaults: SettingDefaults | null;
  onPlace: (theatre: string) => void;
}) {
  const eras = useEras();
  if (!defaults?.theatreMatters) return null;
  const t = ca.missionUi.theatre;
  // The era's own theatres, from the platform's table (era/theatres.json).
  const theatres = theatresOf(eras, defaults.era);
  return (
    <div className={defaults.theatre ? 'theatre-ask' : 'theatre-ask notice warn'}>
      <label>
        {t.where}
        <select
          name="theatre"
          value={defaults.theatre ?? ''}
          onChange={(e) => onPlace(e.target.value)}
        >
          <option value="">{t.unknown}</option>
          {theatres.map((theatre) => (
            <option key={theatre.id} value={theatre.id}>
              {theatre.label}
            </option>
          ))}
        </select>
      </label>
      <p className="muted small">{defaults.theatre ? t.hint : t.ask}</p>
    </div>
  );
}
